import React, {useCallback, useEffect, useState} from 'react';
import Spinner from '../../common/Spinner';
import {Visual} from '../../reports/types';
import {getDashboardVisuals} from '../../../api/reports';
import {useSnackbarHook} from '../../../hooks/useSnackbar';
import CardsSlider from '../slider/CardsSlider';
import Card from './Card';

const HistoricalCards = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [visuals, setVisuals] = useState<Nullable<Visual[]>>(null);

  const {addErrorToast} = useSnackbarHook();

  const getVisuals = useCallback(async () => {
    setIsLoading(true);

    try {
      const newVisuals = await getDashboardVisuals();

      setVisuals(newVisuals);
    } catch (e) {
      addErrorToast(e?.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getVisuals();
  }, [getVisuals]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!visuals?.length) {
    return null;
  }

  return (
    <div className="historical-cards">
      <CardsSlider>
        {visuals.map((visual) => (
          <Card
            key={visual?.visualName}
            visual={visual}
          />
        ))}
      </CardsSlider>
    </div>
  );
};

export default HistoricalCards;
